import { spacing } from '@apia/theme';
import useContext from '../../../../../hooks/useContext';
import IProperty from '../../../../../JSApi/constants/IProperty';
import usePropsSelector from '../../../../../store/propsStore/usePropsSelector';
import { IApiaMultiple } from '../../../../../types';
import { ApiaComponentContextPrimitive } from '../../apiaComponent/ApiaComponentContext';
import { useFieldContext } from '../../fieldsStore/FieldContext';
import { getSelectOptions } from '../ApiaMultiple';
import useApiaFieldCommonProps from '../useApiaFieldCommonProps';

const ApiaMultiple = () => {
  const {
    state: { value },
  } = useFieldContext();
  const { fieldId } = useContext(ApiaComponentContextPrimitive);

  const props = usePropsSelector(fieldId);
  const { field } = props;

  const { attId } = field;
  const isFormReadOnly = props.formData?.readOnly;
  const { identifier } = useApiaFieldCommonProps();
  return (
    <ul
      sx={{
        listStyleType: 'none',
        p: spacing(0),
        m: spacing(0),
      }}
      {...identifier}
    >
      {getSelectOptions((field as IApiaMultiple)?.possibleValue)?.map((opt) => {
        if (opt?.value.toString() !== '') {
          if (!isFormReadOnly && !props[IProperty.PROPERTY_INPUT_AS_TEXT]) {
            return (
              <li
                key={`option_${attId}_${opt?.value}_${opt?.label}`}
                sx={{
                  fontWeight: (value as string[]).includes(
                    opt?.value.toString(),
                  )
                    ? 'bold'
                    : 'normal',
                }}
              >
                {opt?.label}
              </li>
            );
          }
          if ((value as string[]).includes(opt?.value.toString())) {
            return (
              <li key={`option_${attId}_${opt?.value}_${opt?.label}`}>
                {opt?.label}
              </li>
            );
          }
        }
        return null;
      })}
    </ul>
  );
};

export default ApiaMultiple;
